import React, { useState, useEffect, useRef } from "react";
import {
    Layout,
    Table,
    Input,
    Button,
    Form,
    Space,
    theme,
    Popconfirm,
    Row,
    Col,
    Breadcrumb,
    Modal,
    notification,
    Typography,
    Select,
    Tooltip,
    Tag,
    Switch
} from "antd";
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { PlusOutlined, DeleteOutlined, SearchOutlined, CloseCircleFilled, CheckCircleFilled, EditOutlined } from "@ant-design/icons";
import axios from "axios";
import dayjs from "dayjs";
import {MAINAPIURL} from '../appsettings';
import Highlighter from 'react-highlight-words';
const { Content } = Layout;
const { TextArea } = Input;
const { Option } = Select;
const ManageUser = () => {
    const {
        token: { colorBgContainer, borderRadiusLG },
    } = theme.useToken();

    const [users, setUsers] = useState([]);
    const [designations, setDesignations] = useState([]);
    const [roles, setRoles] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [currentUser, setCurrentUser] = useState(null);
    const [addForm] = Form.useForm();
    const [form] = Form.useForm();

    const API_URL = MAINAPIURL;
    const TOKEN = localStorage.getItem("AUTHCODE");
    const UPDATED_BY = localStorage.getItem("USERID");

    const [searchText, setSearchText] = useState('');
    const [searchedColumn, setSearchedColumn] = useState('');
    const searchInput = useRef(null);

    const handleSearch = (selectedKeys, confirm, dataIndex) => {
        confirm();
        setSearchText(selectedKeys[0]);
        setSearchedColumn(dataIndex);
    };
    const handleReset = (clearFilters) => {
        clearFilters();
        setSearchText('');
    };
    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
            <div
                style={{
                    padding: 8,
                }}
                onKeyDown={(e) => e.stopPropagation()}
            >
                <Input
                    ref={searchInput}
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
                    style={{
                        marginBottom: 8,
                        display: 'block',
                    }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Search
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{
                            width: 90,
                        }}
                    >
                        Reset
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            confirm({
                                closeDropdown: false,
                            });
                            setSearchText(selectedKeys[0]);
                            setSearchedColumn(dataIndex);
                        }}
                    >
                        Filter
                    </Button>
                    <Button
                        type="link"
                        size="small"
                        onClick={() => {
                            close();
                        }}
                    >
                        close
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => (
            <SearchOutlined
                style={{
                    color: filtered ? '#1677ff' : undefined,
                }}
            />
        ),
        onFilter: (value, record) =>
            record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
        filterDropdownProps: {
            onOpenChange(open) {
                if (open) {
                    setTimeout(() => searchInput.current?.select(), 100);
                }
            },
        },
        render: (text) =>
            searchedColumn === dataIndex ? (
                <Highlighter
                    highlightStyle={{
                        backgroundColor: '#ffc069',
                        padding: 0,
                    }}
                    searchWords={[searchText]}
                    autoEscape
                    textToHighlight={text ? text.toString() : ''}
                />
            ) : (
                text
            ),
    });

    useEffect(() => {
        fetchUsers();
        fetchActiveDesignations();
        fetchActiveRoles();
    }, [API_URL, TOKEN]);

    const fetchUsers = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${API_URL}/user/listall.php`, {
                headers: {
                    "Content-Type": "application/json",
                    token: TOKEN,
                },
            });
            const mappedUsers = response.data.dataset.map((item) => ({
                userId: item.user_id,
                userName: item.user_name,
                userDisplayName: item.user_dname,
                userEmail: item.user_email,
                userMobile: item.user_mobile,
                userLastupdate: item.user_lastupdate,
                userLastlog: item.user_lastlog,
                userStatus: item.user_status,
                userRoleId: item.role_id,
                userRole: item.role_name,
                userDesiId: item.desi_id,
                userDesignation: item.desi_name,

            }));

            setUsers(mappedUsers);

        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to fetch user.",
            });
        } finally {
            setLoading(false);
        }
    };
    const fetchUserDetailsById = async (id) => {
        try {
            const response = await axios.get(`${API_URL}/user/detail.php?id=${id}`, {
                headers: { "Content-Type": "application/json", token: TOKEN },
            });
            const item = response.data.dataset;
            setCurrentUser(item);
            form.setFieldsValue({
                userId: item.userid,
                userName: item.username,
                userDisplayName: item.userdname,
                userEmail: item.useremail,
                userMobile: item.usermobile,
                userLastupdate: item.userlastupdate,
                userLastlog: item.userlastlog,
                userstatus: item.userstatus === "1",
                userRoleId: item.roleid,
                userRole: item.rolename,
                userDesiId: item.desiid,
                userDesignation: item.desiname,
            });
            setIsModalVisible(true);
        } catch (error) {
            notification.error({ message: "Error", description: "Failed to fetch user details." });
        }
    };

    const handleEdit = (record) => {

        fetchUserDetailsById(record.userId);
    };

    const handleUpdate = async (values) => {
        
        const payload = {
            userid: currentUser.userid,
            username: values.userName,
            displayname: values.userDisplayName,
            designationid: currentUser.desiid,
            userroleid: currentUser.roleid,
            email: values.userEmail,
            mobile: values.userMobile,
            activestatus: values.userstatus ? "1" : "0",
            updatedby: UPDATED_BY,
        };
        try {
            setLoading(true);
            const response = await axios.post(`${API_URL}/user/update.php`, payload, {
                headers: { "Content-Type": "application/json", token: TOKEN },
            });
            if (response.data.status == "success") {
                notification.success({
                    message: "Success",
                    description: response.data.message || "User updated successfully.",
                });
                setIsModalVisible(false);
                fetchUsers();
                form.resetFields();
            } else {
                throw new Error(response.data.message || "Failed to update user");
            }

        } catch (error) {
            notification.error({ message: "Error", description: "Failed to update user." });
        } finally {
            setLoading(false);
        }
    };

    const handleAdd = async (values) => {
        const payload = {
            username: values.userName,
            displayname: values.userDisplayName,
            designationid: values.userDesignation,
            userroleid: values.userRole,
            email: values.userEmail,
            mobile: values.userMobile,
            activestatus: values.userStatus ? "1" : "0",
            createdby: UPDATED_BY,
        };

        try {
            setLoading(true);
            const response = await axios.post(`${API_URL}/user/create.php`, payload, {
                headers: {
                    "Content-Type": "application/json",
                    token: TOKEN,
                },
            });
            if (response.data.status == "success") {
                notification.success({
                    message: "Success",
                    description: response.data.message || "User added successfully.",
                });
                fetchUsers();
                addForm.resetFields();
            } else {
                throw new Error(response.data.message || "Failed to add user");
            }

        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to add user. Please try again.",
            });
        } finally {
            setLoading(false);
        }
    };


    const fetchActiveDesignations = async () => {
        try {
            const response = await axios.get(`${API_URL}/masterdropdown/listof_activedesignations.php`, {
                headers: {
                    "Content-Type": "application/json",
                    token: TOKEN,
                },
            });
            setDesignations(response.data.dataset);
        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to fetch departments.",
            });
        }
    };
    const fetchActiveRoles = async () => {
        try {
            const response = await axios.get(`${API_URL}/masterdropdown/listof_activeusersroles.php`, {
                headers: {
                    "Content-Type": "application/json",
                    token: TOKEN,
                },
            });
            setRoles(response.data.dataset);
        } catch (error) {
            notification.error({
                message: "Error",
                description: "Failed to fetch departments.",
            });
        }
    };

    const columns = [

        {
            title: "Username",
            dataIndex: "userName",
            key: "userName",
            sorter: (a, b) => a.userName.localeCompare(b.userName),
            ...getColumnSearchProps('userName')
        },
        {
            title: "Name",
            dataIndex: "userDisplayName",
            key: "userDisplayName",
            sorter: (a, b) => a.userDisplayName.localeCompare(b.userDisplayName),
            ...getColumnSearchProps('userDisplayName')
        },

        {
            title: "Email",
            key: "userEmail",
            dataIndex: "userEmail",
            ...getColumnSearchProps('userEmail'),
            width: "20%",
        },

        {
            title: "Mobile Number",
            dataIndex: "userMobile",
            key: "userMobile",
            sorter: (a, b) => a.userMobile.localeCompare(b.userMobile),
            ...getColumnSearchProps('userMobile')

        },
        {
            title: "Designation",
            dataIndex: "userDesignation",
            key: "userDesignation",
            sorter: (a, b) => a.userDesignation.localeCompare(b.userDesignation),
            ...getColumnSearchProps('userDesignation')
        },
        {
            title: "Role",
            dataIndex: "userRole",
            key: "userRole",
            sorter: (a, b) => a.userRole.localeCompare(b.userRole),
            ...getColumnSearchProps('userRole')
        },
        {
            title: "Status",
            dataIndex: "userStatus",
            key: "userStatus",
            align: "center",
            width: 100,
            render: (userStatus) =>
                userStatus == 1 ? (
                    <Tooltip title="Active">
                        <CheckCircleFilled style={{ color: "green", fontSize: "18px" }} />
                    </Tooltip>
                ) : (
                    <Tooltip title="Inactive">
                        <CloseCircleFilled style={{ color: "red", fontSize: "18px" }} />
                    </Tooltip>
                ),
        },
        // {
        //     title: "Last Loged",
        //     dataIndex: "userLastlog",
        //     key: "userLastlog",
        //     width: 150,
        //     sorter: (a, b) => a.userLastlog.localeCompare(b.userLastlog),
        //     ...getColumnSearchProps('userLastlog'),
        //     render: (date) => <span>{dayjs(date).format("YYYY-MM-DD")}</span>,
        // },
        {
            title: "Last Updated",
            dataIndex: "userLastupdate",
            key: "userLastupdate",
            width: 150,
            sorter: (a, b) => a.userLastupdate.localeCompare(b.userLastupdate),
            render: (date) => <span>{dayjs(date).format("YYYY-MM-DD")}</span>,
        },
        {
            title: "Action",
            key: "action",
            align: "center",
            fixed: 'right',
            width: 150,
            render: (_, record) => (
                <Space>

                    <Tooltip title="Edit Department">
                        <Button
                            type="text"
                            icon={<EditOutlined />}
                            onClick={() => handleEdit(record)}
                        ></Button>
                    </Tooltip>

                    {/* <Switch
            checked={record.mach_active == 1}
            onChange={() => handleToggleStatus(record)}
            checkedChildren="Inactive"
            unCheckedChildren="Active"
          /> */}
                    {/* <Popconfirm
            title="Are you sure you want to delete this user?"
            onConfirm={() => handleDelete(record.id)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="text" danger icon={<DeleteOutlined />}></Button>
          </Popconfirm> */}

                </Space>
            ),
        },
    ];

    return (
        <Layout style={{backgroundColor:"#e6eeff"}}>
            <Headerdiv />
            <Content style={{ padding: '10px', }} >
                <Breadcrumb style={{ margin: "16px 0" }}>
                    <Breadcrumb.Item>User Management</Breadcrumb.Item>
                </Breadcrumb>
                <div
                    style={{
                        padding: 10,
                        minHeight: "65vh",
                        background: colorBgContainer,
                        borderRadius: borderRadiusLG,
                    }}
                >
                    <Space
                        direction="vertical"
                        style={{ width: "100%", padding: "15px" }}
                    >
                        <Row gutter={[16, 16]} style={{ width: "100%", border: "1px solid #ddd", padding: "0 16px", alignContent: "" }}>
                            <Col xs={24} >

                                <Form
                                    form={addForm}
                                    layout="vertical"
                                    onFinish={handleAdd}
                                    style={{ width: "100%" }}
                                >
                                    <Typography.Title level={5} style={{ fontSize: "14px", padding: "0 0 5px 0" }}>Add New User</Typography.Title>

                                    <Row gutter={[16, 16]} style={{ rowGap: "0", justifyContent: "space-between" }}>
                                        <Col xs={24} md={24}>
                                            <Row xs={24} md={24}>
                                                <Col xs={24} md={6} style={{ padding: "0 5px 0 5px" }}>
                                                    <Form.Item label="Username" name="userName" rules={[
                                                        { required: true, message: "Please enter a username" },
                                                        { min: 6, max: 15, message: "Username must be 6-15 characters long" },
                                                        { pattern: /^[a-zA-Z0-9]+$/, message: "Username can only contain letters and numbers" },
                                                    ]}
                                                    >
                                                        <Input

                                                            placeholder="Enter User Name"
                                                            style={{ width: "100%", margin: "0" }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={6} style={{ padding: "0 5px 0 5px" }}>
                                                    <Form.Item
                                                        label="Name"
                                                        name="userDisplayName"
                                                        rules={[{ required: true, message: "Please enter Name" }]}
                                                    >
                                                        <Input

                                                            placeholder="Enter Name"
                                                            style={{ width: "100%", margin: "0" }}
                                                        />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={6} style={{ padding: "0 5px 0 5px" }}>
                                                    <Form.Item
                                                        label="Designation"
                                                        name="userDesignation"
                                                        rules={[{ required: true, message: "Please select a designation" }]}
                                                    >
                                                        <Select placeholder="Select Designation">
                                                            {designations.map((desi) => (
                                                                <Select.Option key={desi.value} value={desi.value}>
                                                                    {desi.label}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={6} style={{ padding: "0 5px 0 5px" }}>
                                                    <Form.Item label="User Role" name="userRole" rules={[{ required: true, message: "Please Select User Role" }]}>
                                                        <Select placeholder="Select User Role">
                                                            {roles.map((role) => (
                                                                <Select.Option key={role.value} value={role.value}>
                                                                    {role.label}
                                                                </Select.Option>
                                                            ))}
                                                        </Select>
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row xs={24} md={24} style={{ alignItems: "flex-end" }}>
                                                <Col xs={24} md={6} >
                                                    <Form.Item
                                                        name="userEmail"
                                                        label="E-mail"
                                                        rules={[
                                                            {
                                                                type: 'email',
                                                                message: 'The input is not valid E-mail!',
                                                            },
                                                            {
                                                                required: true,
                                                                message: 'Please input your E-mail!',
                                                            },
                                                        ]}
                                                    >
                                                        <Input />
                                                    </Form.Item>
                                                </Col>
                                                <Col xs={24} md={6} >
                                                    <Form.Item
                                                        name="userMobile"
                                                        label="Mobile Number"
                                                        rules={[
                                                            { required: true, message: "Please input your phone number!" },
                                                            { pattern: /^7\d{8}$/, message: "Contact must be 9 digits, starting with 7" },
                                                        ]}
                                                        style={{ padding: "0 5px 0 5px" }}
                                                    >
                                                        <Input

                                                            maxLength={9}
                                                            placeholder="7XXXXXXXX"

                                                        />
                                                    </Form.Item>
                                                </Col>

                                                <Col xs={24} md={12}  >
                                                    <Row xs={24} md={24} style={{ alignItems: "flex-end", justifyContent: "end" }}>
                                                        <Col xs={8} md={4} >
                                                            <Form.Item name="userStatus" label="Active" valuePropName="checked" style={{ padding: "0 0 0 8px" }} >
                                                                <Switch />
                                                            </Form.Item>
                                                        </Col>
                                                        <Col xs={16} md={12} style={{ padding: "0 0 0 8px" }}>
                                                            <Form.Item >
                                                                <Button
                                                                    type="primary"
                                                                    htmlType="submit"
                                                                    icon={<PlusOutlined />}
                                                                    loading={loading}
                                                                    style={{ width: "100%", margin: "0" }}
                                                                >
                                                                    Add User
                                                                </Button>
                                                            </Form.Item>
                                                        </Col>
                                                    </Row>

                                                </Col>

                                            </Row>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                        <Row style={{ width: "100%" }} >
                            <Col xs={24} md={24}>
                                <Typography.Title level={5}>List of Users</Typography.Title>
                            </Col>
                            <Col xs={24} md={24}>
                                <Table
                                    size="small"
                                    columns={columns}

                                    dataSource={users}
                                    rowKey="id"
                                    pagination={{ pageSize: 5 }}
                                    bordered
                                    scroll={{ x: 1000 }}


                                />
                            </Col>
                        </Row>
                    </Space>
                </div>
                <Modal
                    title="Edit User Details"
                    visible={isModalVisible}
                    onCancel={() => setIsModalVisible(false)}
                    footer={null}
                >
                    <Form form={form} onFinish={handleUpdate} layout="vertical">

                        <Row>
                            <Col xs={24} md={12}>
                                <Form.Item label="Username" name="userName" rules={[
                                    // { required: true, message: "Please enter a username" },
                                    // { min: 6, max: 15, message: "Username must be 6-15 characters long" },
                                    // { pattern: /^[a-zA-Z]+$/, message: "Username can only contain letters" },
                                ]}
                                >
                                    <Input
                                        disabled
                                        placeholder="Enter User Name"
                                        style={{ width: "100%", margin: "0" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>
                                <Form.Item
                                    label="Name"
                                    name="userDisplayName"
                                    rules={[{ required: true, message: "Please enter Name" }]}
                                >
                                    <Input

                                        placeholder="Enter Name"
                                        style={{ width: "100%", margin: "0" }}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    label="Designation"
                                    name="userDesignation"
                                    rules={[{ required: true, message: "Please select a designation" }]}
                                >
                                    <Select placeholder="Select Designation">
                                        {designations.map((desi) => (
                                            <Select.Option key={desi.value} value={desi.value}>
                                                {desi.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>
                                <Form.Item label="User Role" name="userRole" rules={[{ required: true, message: "Please Select User Role" }]}>
                                    <Select placeholder="Select User Role">
                                        {roles.map((role) => (
                                            <Select.Option key={role.value} value={role.value}>
                                                {role.label}
                                            </Select.Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row>
                            <Col xs={24} md={12}>
                                <Form.Item
                                    name="userMobile"
                                    label="Mobile Number"
                                    rules={[
                                        { required: true, message: "Please input your phone number!" },
                                        { pattern: /^7\d{8}$/, message: "Contact must be 9 digits, starting with 7" },
                                    ]}
                                >
                                    <Input

                                        maxLength={9}
                                        placeholder="7XXXXXXXX"
                                        style={{ width: "100%" }}
                                    />
                                </Form.Item>
                            </Col>
                            <Col xs={24} md={12} style={{ padding: "0 0 0 5px" }}>

                                <Form.Item
                                    name="userEmail"
                                    label="E-mail"
                                    rules={[
                                        {
                                            type: 'email',
                                            message: 'The input is not valid E-mail!',
                                        },
                                        {
                                            required: true,
                                            message: 'Please input your E-mail!',
                                        },
                                    ]}
                                >
                                    <Input />
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24} md={12}>
                                <Form.Item name="userstatus" label="Active" valuePropName="checked" style={{ padding: "0 0 0 8px" }} >
                                    <Switch onChange={(checked) => form.setFieldsValue({ userstatus: checked ? 1 : 0 })} />
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row >
                            {/* <Button type="primary" htmlType="submit" loading={loading} >
                                Update
                            </Button> */}
                            <Form.Item>
                                <Space>
                                    <Button type="primary" htmlType="submit" disabled={loading}>
                                        Save Changes
                                    </Button>
                                    <Button
                                        onClick={() => {
                                            setIsModalVisible(false);

                                            form.resetFields();
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Space>
                            </Form.Item>
                        </Row>

                    </Form>
                </Modal>
            </Content>
            <Footerdiv />

        </Layout>
    );
};

export default ManageUser;